import styled, { css } from "styled-components";
import { experienceEasterPath } from "../../../../paths";

import { IStyleProps } from "./interfaces";

export const ScoreWrapper = styled.div<IStyleProps>`
    overflow: hidden;
    margin-top: 60px;
    height: calc(100% - 60px - ${p => p.hasDownExtended ? 240 : 192}px);
    ${p => p.isEaster && css`
        margin-top: 115px;
        margin-left: 116px;
        margin-right: 88px;
        margin-bottom: 12px;
        height: calc(100% - 60px - 180px - 92px);
    `}
    ${p =>
        p.isLow
            ? css`
                  height: 270px;
                  width: 720px;
                  margin: auto;
                  margin-top: 120px;
                  border-radius: 30px;
                  border: 2px solid black;
                  -webkit-mask-image: -webkit-radial-gradient(white, black);
              `
            : undefined}
`;

export const EasterBackground = styled.div`
    background-image: url("${experienceEasterPath}/easter-score-background.svg");
    background-size: 100% 100%;
    position: absolute;
    top: 64px;
    left: -9px;
    right: -6px;
    bottom: 176px;
    z-index: -1;
`;

const padding = 20;
export const ChristmasBackground = styled.div`
    background-color: ${p => p.theme.c.christmasBlue};
    box-shadow: 0 0 0 6px ${p => p.theme.c.christmasLightBlue} inset;
    position: absolute;
    top: ${115 - padding}px;
    left: ${116 - padding}px;
    right: ${88 - padding}px;
    bottom: ${218 - padding}px;
    z-index: -1;
`;

export const SolfaLadderWrapper = styled.div<IStyleProps>`
    ${p =>
        p.isLow
            ? css`
                  margin-top: 15px;
              `
            : undefined}

    ${p =>
        p.isLow
            ? css`
                  transform: scale(0.75);
              `
            : undefined}

    &.Completed {
        opacity: 0.4;
        pointer-events: none;
        transition: 2s;
    }
`;

export const Asset1Wrapper = styled.div`
    position: absolute;
    bottom: 0;
    left: -20px;
    pointer-events: none;

    img {
        width: 254px;
    }
`;

export const Asset2Wrapper = styled.div`
    position: absolute;
    bottom: -30px;
    right: -30px;
    pointer-events: none;
    img {
        width: 458px;
    }
`;
